import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  toggleMobileMenu(){
    const mobileMenu = document.getElementById("mobile-menu");
    mobileMenu.classList.toggle("closed");
    this.element.classList.toggle("open");
  }
}
